package org.braunequip.web.pages.braunadmin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import org.braunequip.web.components.layouts.AdminPageLayout
import org.braunequip.web.components.sections.AdminTables.AdminEmployeePinsTable
import org.braunequip.web.components.sections.AdminTables.AdminEmployeesTable
import org.braunequip.web.util.Routes.Admin.FRONT_EMPLOYEE_ROUTE
import org.braunequip.web.util.isUserLoggedIn
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Section

@Page
@Composable
fun AdminEmployeesPage() {
    isUserLoggedIn {
        AdminPageLayout {
            AdminEmployeesScreen()
        }
    }
}

@Composable
fun AdminEmployeesScreen() {
    val context = rememberPageContext()
    val refreshedTab = remember(key1 = context.route) { context.route.params["tab"] ?: ""}

    Section(
        attrs = Modifier
            .padding(16.px)
            .fillMaxSize()
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .toAttrs()
    ) {

        AdminFormTabs(
            tabs = listOf(
                "Employees",
                "Employee Portal Pins"
            ),
            tabViewStyle = Modifier
                .fillMaxSize(),
            contentBlocks = listOf(
                { AdminEmployeesTable() },
                { AdminEmployeePinsTable() }
            ),
            refreshedTab = refreshedTab,
            onSelectedTab = { tabIndex ->
                context.router.navigateTo("$FRONT_EMPLOYEE_ROUTE?tab=$tabIndex")
            }
        )
    }
}
